export default {
  our: {
    en: 'Our',
    fr: 'Notre',
  },
  mission: {
    en: 'mission',
    fr: 'mission',
  },
  mission_content: {
    fr: "Chez GéniALE notre mission est de développer des technologies dans le domaine brassicole afin d’automatiser et d’optimiser les procédés de brassage. En collaboration avec de grands joueurs de l’industrie, le club se concentre sur le développement de nouvelles technologies dans le but d'améliorer les procédés existants.",
    en: 'At GéniALE, our mission is to develop technologies in the brewing industry to automate and optimize brewing processes. In collaboration with major players in the industry, the club focuses on developing new technologies to improve existing processes.',
  },
  get_in_touch_button: {
    en: 'Get in touch with us',
    fr: 'Contactez-nous pour en savoir plus',
  },
  ingredients: {
    fr: 'Ingrédients',
    en: 'ingredients',
  },
  local: {
    fr: 'locaux',
    en: 'Local',
  },
  ingredients_content: {
    en: 'We use locally sourced ingredients and materials to brew our beer. This not only supports local businesses but also reduces our carbon footprint.',
    fr: 'Nous utilisons des ingrédients et des matériaux locaux pour brasser notre bière. Cela soutient non seulement les entreprises locales, mais réduit également notre empreinte carbone.',
  },
  beer_quality_title: {
    fr: 'Une bière de',
    en: 'beer',
  },
  quality: {
    fr: 'qualité',
    en: 'Quality',
  },
  beer_quality_content: {
    en: 'We take pride in brewing high-quality beer that is both delicious and refreshing. Our team of experienced brewers uses only the best ingredients and techniques to create unique flavors and aromas.',
    fr: "Nous sommes fiers de brasser une bière de haute qualité, à la fois délicieuse et rafraîchissante. Notre équipe de brasseurs expérimentés n'utilise que les meilleurs ingrédients et techniques pour créer des saveurs et des arômes uniques.",
  },
  brewing_title: {
    en: 'Recipe designed from',
    fr: 'Recette conçus de',
  },
  scratch_title: {
    en: 'scratch',
    fr: 'A à Z',
  },
  brewing_content: {
    fr: 'Notre équipe de brasseurs passionnés travaille dur pour créer des recettes uniques et délicieuses. Nous brassons chaque lot avec soin, en utilisant des techniques traditionnelles et des équipements modernes.',
    en: 'Our team of passionate brewers works hard to create unique and delicious recipes. We brew each batch with care, using traditional techniques and modern equipment.',
  },
  join_our_team_title: {
    en: 'Join our team',
    fr: 'Rejoins notre équipe',
  },
  join_our_team_content: {
    en: 'We are always looking for talented individuals to join our team. If you are passionate about brewing and want to be part of a dynamic and innovative club, we would love to hear from you.',
    fr: "Nous sommes toujours à la recherche de personnes talentueuses pour rejoindre notre équipe. Si vous êtes passionné par le brassage et souhaitez faire partie d'un club dynamique et innovant, nous aimerions avoir de vos nouvelles.",
  },
  join_us: {
    en: 'Join us',
    fr: 'Rejoins nous',
  },
  people_that_love_to_work_with_us: {
    en: 'People that love to work with us',
    fr: 'Ceux qui aiment travailler avec nous',
  },
  view_partner_plan: {
    en: 'View our partner plan',
    fr: 'Voir notre plan de partenariat',
  },
};
